/**
 * Return an array of child elements that can get focus.  Excludes hp6 elements.
 *
 * @param element The HTMLElement for which to return children that are focusable elements
 * @returns HTMLElement[]
 */
const getFocusableElements = (element: HTMLElement | ShadowRoot): HTMLElement[] => {
  if (!element) {
    // make an empty node list
    return [] as HTMLElement[];
  }

  // array returned needs to be in DOM order in order for hp-focus-trap to work
  // using the multiple tag query selector will return the elements in DOM order
  const htmlNodeList = element.querySelectorAll(
    `button:not([tabindex="-1"]),
     input:not([tabindex="-1"]),
     select:not([tabindex="-1"]),
     textarea:not([tabindex="-1"]),
     [href]:not([tabindex="-1"]),
     [tabindex]:not([tabindex="-1"]),
     [data-hp-no-focus]`,
  );

  const filtered = Array.from(htmlNodeList).filter(
    tag => tag.tagName.toUpperCase().indexOf('HP6-') < 0,
  ) as HTMLElement[];

  return filtered;
};

export default getFocusableElements;
